<div class="chat-selection-wrapper">
    <div class="chat-selection-header">
        <span class="title">Select output from {{selectedQuestion}}</span>
    </div>
    <div class="chat-selection-body">
        <div class="content-body">
            @for (chat of chatData; track $index) {
                <div class="chat-item chat-selection-item">
                    <div class="checkbox">
                        <mat-checkbox
                              class="modified-checkbox"
                              (change)="selectChat($event, chat)"
                            >
                        </mat-checkbox>
                    </div>
                    <div class="chat-answer" [innerHTML]="chat.message_text"></div>
                </div>
                <br>
            }
        </div>
    </div>
    <div class="chat-selection-footer">
        <div class="chat-selected">
            <span *ngIf="selectedChatData.length > 0">{{selectedChatData.length}} Output Selected</span>
        </div>
        <div class="btn-grp">
            <button class="plain-btn" (click)="onClose()">Cancel</button>
            <app-button [style]="selectedChatData.length == 0 ? 'opacity: 0.6; pointer-events: none;' : 'opacity: 1; pointer-events: unset;'" [type]="'primary'" [buttonType]="'button'" [buttonText]="'Submit'" (onClick)="onSubmit($event)"></app-button>

        </div>
    </div>
</div>
